var map = {
	"./4db8c94e-7e49-4efd-9058-7641d0ac6627.JPG": 160,
	"./AbdulKhaliq.jpeg": 161,
	"./AbdulKhaliqDS.jpeg": 162,
	"./AbdulRasheed.jpeg": 163,
	"./AmeenTanoli.jpeg": 164,
	"./AsifAliAkber.jpeg": 165,
	"./AzizUrRehman.jpeg": 166,
	"./EidMilanParty.jpeg": 167,
	"./FB_IMG_1558775250680.jpg": 168,
	"./HajiYonusTanoli.jpeg": 169,
	"./IsraarKhan.jpeg": 170,
	"./JawaidWali(F)(B).jpeg": 91,
	"./JunaidYousuf.jpeg": 171,
	"./KamranQamarTanoli.jpg": 172,
	"./KhalidMerajKhan.jpeg": 173,
	"./Khursheed.jpeg": 174,
	"./MuhammadAfzalTanoli.jpg": 175,
	"./MuhammadAsif.jpeg": 176,
	"./MuhammadEjaz.jpeg": 177,
	"./MuhammadFaisalImage(B).JPG": 178,
	"./MuhammadSaqib.jpeg": 179,
	"./MuhammadTanveerTanoli(F)(S).JPG": 92,
	"./MuhammadUmerKhalid.jpeg": 180,
	"./RizwanTanoli.jpeg": 181,
	"./Sajjad.jpeg": 182,
	"./SufiHakim.jpeg": 183,
	"./ZakirTanoli.jpeg": 184,
	"./address_image.svg": 185,
	"./akhunzada.jpeg": 186,
	"./animated_ashutosh.png": 187,
	"./animated_logo.svg": 188,
	"./blogs_image.svg": 189,
	"./camp1.jpeg": 190,
	"./camp2.jpeg": 191,
	"./camp3.jpeg": 94,
	"./camp4.jpeg": 95,
	"./camp5.jpeg": 192,
	"./chairman.jpeg": 193,
	"./chairman.jpg": 194,
	"./child.png": 195,
	"./cloud_infrastructure.svg": 196,
	"./codeInLogo.png": 197,
	"./contactMail.png": 198,
	"./coursera_logo.png": 199,
	"./data_science.svg": 200,
	"./deeplearning_ai_logo.png": 201,
	"./delhivery_logo.png": 202,
	"./developerActivity.svg": 203,
	"./dsc_logo.png": 204,
	"./dsfd.JPG": 205,
	"./education.svg": 206,
	"./experience.svg": 207,
	"./feelingProud.svg": 208,
	"./freecopy_logo.png": 209,
	"./fullstack.svg": 210,
	"./gcp_logo.png": 211,
	"./github_logo.png": 212,
	"./givingPrize1.jpeg": 213,
	"./givingPrize2.jpeg": 214,
	"./givingPrize3.jpeg": 215,
	"./googleAssistant.jpg": 216,
	"./googleAssistant.svg": 217,
	"./google_logo.png": 218,
	"./ibm_logo.png": 219,
	"./iiitk_logo.png": 220,
	"./intel_logo.jpg": 221,
	"./jk.jpg": 222,
	"./jsFramework.svg": 223,
	"./kharyalaMainImg.jpeg": 224,
	"./legato_logo.png": 225,
	"./logo.jpg": 83,
	"./logo.png": 226,
	"./main.png": 227,
	"./main1.png": 228,
	"./main2.jpeg": 93,
	"./main3.jpeg": 229,
	"./main4.jpeg": 230,
	"./main5.jpeg": 231,
	"./main6.jpeg": 86,
	"./manOnTable.svg": 232,
	"./microsoft_logo.png": 233,
	"./mozilla_logo.png": 234,
	"./muffito_logo.png": 235,
	"./needy.jpeg": 236,
	"./nextuLogo.jpg": 237,
	"./noUser.png": 238,
	"./nptel_logo.png": 239,
	"./portfolio.gif": 240,
	"./programmer.svg": 241,
	"./projects_image.svg": 242,
	"./pwa.png": 243,
	"./ration.jpg": 89,
	"./saayaHealthLogo.png": 244,
	"./stanford_logo.png": 245,
	"./talksCardBack.svg": 246,
	"./talksCardBackAlt.svg": 247,
	"./themain.jpeg": 88,
	"./themainmain.jpeg": 248,
	"./ui_ux_design.svg": 249,
	"./village.jpeg": 250,
	"./weddingEvent.jpeg": 251
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47;